module.exports = __webpack_public_path__ + "img/sklep-defence-24.7449f5df.svg";